<section id="profile-info">
    <div class="row">
        <div class="col-lg-12 col-12 order-1 order-lg-2">
            <div class="form-group mb-2">
                <div class="card">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <h2>Fee Structure</h2>
                        <div class="btn-group" role="group">
                            <button type="button" class="btn btn-sm btn-outline-primary"
                                    (click)="addEditorBlock('content')">
                                Content
                            </button>
                            <button type="button" class="btn btn-sm btn-outline-primary"
                                    (click)="addEditorBlock('table')">
                                Table
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <ng-container *ngFor="let block of editorBlocks; let i = index">
                            <div class="d-flex justify-content-end mb-1">
                                <button class="btn btn-icon btn-flat-danger" rippleEffect type="button"
                                        title="Remove" (click)="removeEditorBlock(i)">
                                    <i data-feather="trash-2"></i>
                                </button>
                            </div>
                            <quill-editor *ngIf="block.type === 'content'" class="university-info mb-3"
                                          [(ngModel)]="block.value" name="quill-content-{{i}}"></quill-editor>

                            <div *ngIf="block.type === 'table'" class="mb-3">
                                <editor [apiKey]="tinymceApiKey" [(ngModel)]="block.value" [init]="tableEditorInit"
                                        name="table-content-{{i}}"></editor>
                            </div>
                        </ng-container>
                    </div>
                    <div class="card-footer">
                        <button class="btn btn-primary pull-right" rippleEffect [disabled]="submitting" (click)="submit()">
                            <i data-feather="check" class="d-block d-md-none"></i>
                            <span class="font-weight-bold d-none d-md-block">{{submitting ? 'Saving...' : 'Submit'}}</span>
                        </button>
                    </div>
                </div>
            </div>

            <!-- Superseded by the rich table editor above (table_html) — kept commented out for now
                 in case the structured "Add University" table needs to come back.
            <div class="form-group mb-2">
                <div class="card">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <h2>Top Universities' Course Fees Table</h2>
                        <button class="btn btn-outline-primary btn-sm" rippleEffect type="button" (click)="addRow()">
                            <i data-feather="plus" class="mr-1"></i>
                            Add University
                        </button>
                    </div>
                    <div class="card-body">
                        <div class="border rounded p-3 mb-3" *ngFor="let row of tableRows; let i = index">
                            <div class="d-flex align-items-start justify-content-between mb-2">
                                <div class="flex-grow-1 mr-2">
                                    <div class="form-group mb-2">
                                        <label>University Name</label>
                                        <input type="text" class="form-control" [(ngModel)]="row.universityName"
                                               name="university-name-{{i}}" placeholder="e.g. Golden Gate University Online MBA">
                                    </div>
                                    <div class="form-group mb-2">
                                        <label>University Link <span class="text-muted">(optional)</span></label>
                                        <input type="text" class="form-control" [(ngModel)]="row.universityLink"
                                               name="university-link-{{i}}" placeholder="/university/golden-gate-university">
                                    </div>
                                    <div class="form-group mb-0">
                                        <label>Course Fees</label>
                                        <input type="text" class="form-control" [(ngModel)]="row.courseFees"
                                               name="course-fees-{{i}}" placeholder="e.g. INR 4.30 lakhs">
                                    </div>
                                </div>
                                <button class="btn btn-icon btn-flat-danger mt-2" rippleEffect type="button"
                                        title="Remove University" (click)="removeRow(i)">
                                    <i data-feather="trash-2"></i>
                                </button>
                            </div>

                            <label>Detailed Fee Structure</label>
                            <div class="d-flex align-items-center mb-1" *ngFor="let detail of row.feeDetails; let j = index">
                                <input type="text" class="form-control mr-2" [(ngModel)]="row.feeDetails[j]"
                                       name="fee-detail-{{i}}-{{j}}" placeholder="e.g. Full program fees&mdash;INR 4.30 lakhs">
                                <button class="btn btn-icon btn-flat-danger" rippleEffect type="button"
                                        title="Remove Detail" (click)="removeFeeDetail(i, j)">
                                    <i data-feather="x"></i>
                                </button>
                            </div>
                            <button class="btn btn-outline-secondary btn-sm mt-1" rippleEffect type="button"
                                    (click)="addFeeDetail(i)">
                                <i data-feather="plus" class="mr-1"></i>
                                Add Fee Detail Line
                            </button>
                        </div>

                        <p class="text-muted mb-0" *ngIf="tableRows.length === 0">
                            No universities added yet. Click "Add University" to start building the table.
                        </p>
                    </div>
                    <div class="card-footer">
                        <button class="btn btn-primary pull-right" rippleEffect [disabled]="submitting" (click)="submit()">
                            <i data-feather="check" class="d-block d-md-none"></i>
                            <span class="font-weight-bold d-none d-md-block">{{submitting ? 'Saving...' : 'Submit'}}</span>
                        </button>
                    </div>
                </div>
            </div>
            -->
        </div>
    </div>
</section>
